import { Component, OnInit } from '@angular/core';
import {DataSharingService} from '../iBoxx/services/data-sharing.service';
import {Router} from '@angular/router';
import {ApiService} from '../iBoxx/services/api.service';
import {UtilService} from '../iBoxx/services/UtilService';
import {ColDef} from 'ag-grid-community';
import {ConstituentData} from '../iBoxx/modals/ConstituentData';
import {PagingModel} from '../iBoxx/shared/pagination-control/PagingModel';
import {LoaderService} from '../iBoxx/shared/loader/loader-service.services';

@Component({
  selector: 'app-ucits-details-page',
  templateUrl: './ucits-details-page.component.html',
  styleUrls: ['./ucits-details-page.component.scss']
})
export class UcitsDetailsPageComponent implements OnInit {

  indexName = '';
  filterParamsForDate = {
    browserDatePicker: true,
    minValidYear: 1900,
    maxValidYear: 9999,
    comparator: (filterLocalDateAtMidnight: Date, cellValue: string) => {
      if (cellValue === null) {
        return -1;
      }
      const dateParts = cellValue.split('T')[0].split('-');
      const cellDate = new Date(
        Number(dateParts[0]),
        Number(dateParts[1]) - 1,
        Number(dateParts[2])
      );
      return cellDate.getTime() === filterLocalDateAtMidnight.getTime() ? 0 :
        cellDate.getTime() < filterLocalDateAtMidnight.getTime() ? -1 : 1;
    }
  };
  columnDefs: ColDef[] = [
    {
      headerName: 'Report Date', width: 140, field: 'asOf', tooltipField: 'asOf', sortable: true,
      filter: 'agDateColumnFilter', floatingFilter: true,
      valueFormatter: (params: any) => params.value !== null ? params.value.split('T')[0] : params.value,
      filterParams: this.filterParamsForDate
    },
    {
      headerName: 'Rebalance Date', width: 140, field: 'rebalancingDate', tooltipField: 'rebalancingDate', sortable: true,
      sort: 'desc', unSortIcon: true, filter: 'agDateColumnFilter', floatingFilter: false,
      valueFormatter: (params: any) => params.value !== null ? params.value.split('T')[0] : params.value,
      filterParams: this.filterParamsForDate
    },
    {headerName: 'Issuer', width: 300, field: 'issuer', sortable: true, filter: true, floatingFilter: true},
    {
      headerName: 'Coupon In %', headerTooltip: 'Coupon In %', width: 100, field: 'coupon',
      filter: 'agNumberColumnFilter', floatingFilter: true,
      valueFormatter: (params: any) => params.value.toFixed(4),
      sortable: true, comparator: (valueA: number, valueB: number) => valueA - valueB
    },
    {
      headerName: 'Maturity Date', width: 140, field: 'maturityDate', sortable: true,
      filter: 'agDateColumnFilter', floatingFilter: true,
      valueFormatter: (params: any) => params.value !== null ? params.value.split('T')[0] : params.value,
      filterParams: this.filterParamsForDate
    },
    {
      headerName: 'Index Weight in %', width: 140, field: 'indexWeight', sortable: true,
      comparator: (valueA: number, valueB: number) => valueA - valueB
    },
  ];
  rowData: ConstituentData[] = [];
  rowDataForUCITS: ConstituentData[] = [];
  pagingInfo: PagingModel = new PagingModel();
  indexGrid: any;
  sortOnColumn = 'rebalancingDate';
  currentOrder = 'DESC';

  constructor(private shareService: DataSharingService, private route: Router,
              private apiService: ApiService, private utilService: UtilService, private loader: LoaderService) { }

  ngOnInit(): void {
    const urlSub = this.shareService.indexURL.subscribe((resp: any) => {
      const ID = resp.split('=')[1];
      this.apiService.getIndexNameFor(ID).subscribe((res: any) => {
        this.indexName = res[0].indexName;
      });
      this.fetchConstituentsFor(ID);
    });

    if (urlSub) {
      urlSub.unsubscribe();
    }
  }

  onGridReady(event: any): void {
    this.indexGrid = event.api;
  }

  fetchConstituentsFor(identifier: string): void{
    this.loader.show();
    this.apiService.getConstituentDataForUCITS(identifier).subscribe((resp: any) => {
      this.populateConstituentData(resp.constituentsList);
      this.loader.hide();
    });
  }

  populateConstituentData(constituents: any): void {
    this.rowData = [];
    constituents.forEach((constituent: any) => {
      const consttuentData: ConstituentData = new ConstituentData();
      consttuentData.asOf = constituent.asOf;
      // @ts-ignore
      consttuentData.indexWeight = (constituent.indexWeight * 100).toFixed(4);
      consttuentData.coupon = constituent.bondRebalancing ? constituent.bondRebalancing.coupon : constituent.loanRebalancing.coupon;
      consttuentData.issuer = constituent.bondRebalancing ? constituent.bondRebalancing.issuer : constituent.loanRebalancing.issuer;
      consttuentData.maturityDate = constituent.bondRebalancing ? constituent.bondRebalancing.workoutDate :
        constituent.loanRebalancing.maturityDate;
      consttuentData.rebalancingDate = constituent.rebalancingDate;
      this.rowData.push(consttuentData);
    });
    console.log(this.rowData);
    this.initPaging();
  }

  initPaging(): void {
    this.pagingInfo.totalRows = this.rowData.length;
    this.pagingInfo.pageSize = 15;
    this.pagingInfo.visibleRows = 15;
    this.pagingInfo.totalPages = Math.ceil(this.pagingInfo.totalRows / this.pagingInfo.pageSize);
  }

  changePage(): void {
    this.indexGrid.paginationGoToPage(this.pagingInfo.page);
    this.indexGrid.paginationSetPageSize(this.pagingInfo.pageSize);
  }

  goBack(): void{
    this.route.navigateByUrl('listUCITS');
  }
}
